import { useDispatch, useSelector } from 'react-redux';
import { loginThunk, logout, fetchProfileThunk } from '../features/auth/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  const login = (credentials) => dispatch(loginThunk(credentials));
  const logoutUser = () => dispatch(logout());
  const fetchProfile = () => dispatch(fetchProfileThunk());

  return {
    ...authState,
    login,
    logoutUser,
    fetchProfile,
  };
};
